<template>
  <div class="FormGrades">
    <div id="refNoData" class="refNoData noShow">
    <va-notification
      color="danger"
    >No se encontró información del Grado solicitado.</va-notification>
    </div>
    <div id="FormGrades2"  class="FormGrades2 noShow">
      <div>
        <b-modal v-model="modalShow" hide-footer title="Estimado(a) Estudiante">
          <div class="d-block">
            <h3>{{infoMsgModal}}</h3>
          </div>
          <br>
          <div class="d-block">
            <h3>Para mayor informacion puedes comunicarte al numero +601 746 68 76 o al correo servicioalestudiante@ibero.edu.co</h3>
          </div>
          <b-button class="mt-3 modal-close-btn" block v-on:click="closeModel">Cerrar</b-button>
        </b-modal>
    </div>
    <div v-if="FormGrades">
      <form-wizard @on-complete="onComplete" next-button-text="Siguiente" back-button-text="Regresar" finish-button-text="Finalizar" title subtitle color="#a2273c">
        <tab-content :title="this.labelFields.fields0" icon="fa fa-life-ring" :before-change="beforeTabSwitch0">
          <div class="container">
            <div class="row">
              <div class="col-md-12 infoForm">
                <FormDataGrades />
              </div>
              <div class="col-md-12 totalform">
                <ValidationObserver ref="obsFields0">
                  <formGrade :FieldsForm="formGrade.fields0" :ModelForm="formGradeModel" :method="executeProcess" />
                </ValidationObserver>
              </div>
            </div>
          </div>
        </tab-content>
        <tab-content :title="this.labelFields.fields1" icon="fa fa-user-circle-o" :before-change="beforeTabSwitch1">
          <div class="container">
            <div class="row">
              <div class="col-md-12 totalform">
                <div class="intro"><p>{{TitleInscrip}}</p>
                </div>
                <div v-if="infoValidacion" class="alert alert-warning">
                  <p>
                    Estimado(a) estudiante: Es importante que valide la informacion suministrada, si tienes alguna inconsistencia, comunicarte con servicioalestudiante@ibero.edu.co
                  </p>
                </div>
                <ValidationObserver ref="obsFields1">
                  <formGrade :FieldsForm="formGrade.fields1" :ModelForm="this.formGradeModel" :method="executeProcess" />
                </ValidationObserver>
              </div>
            </div>
          </div>
        </tab-content>
        <tab-content :title="this.labelFields.fields2" icon="fa fa-book" :before-change="beforeTabSwitch2">
          <div class="container">
            <div class="row">
              <div class="col-md-12 totalform">
                <div class="intro"><p>Carga Documentación {{ModalitySelected}}</p></div>
                <div v-if="alertdanger" class="alert alert-danger">
                  <p>
                    Estimado(a) estudiante: Es importante que valide la informacion suministrada, todos los campos de documentos son obligatorios para generar la inscripción
                  </p>
                </div>
                <ValidationObserver ref="obsFields2">
                  <formGrade :FieldsForm="formGrade.fields2" :ModelForm="this.formGradeFileModel" :method="executeProcess" />
                </ValidationObserver>
              </div>
            </div>
          </div>
        </tab-content>
        <tab-content :title="this.labelFields.fields3" icon="fa fa-pencil-square-o">
          <div class="container">
            <div class="row">
              <div class="col-md-12 totalform">
                <div v-if="alertdanger" class="alert alert-danger" role="alert">
                  Se ha generado un problema con la información ingresada, por favor intente nuevamente el registro.
                </div>
                <FormDataFinishGrades />
                <div class="row summary-section mt-4">
                  <div class="col-md-6 mb-3">
                    <div class="card p-3 shadow-sm h-100">
                      <h5 class="summary-title"><i class="fa fa-user mr-2"></i>Datos Estudiante</h5>
                      <ul class="summary-list">
                        <li><strong>Tipo de Documento:</strong> {{dataObjAllFind($store.state.DocTypesList, formGradeModel.IdDocType).value}}</li>
                        <li><strong>Número de Documento:</strong> {{formGradeModel.IdDocument}}</li>
                        <li><strong>Código del Estudiante:</strong> {{formGradeModel.IdBanner}}</li>
                        <li><strong>Nombres:</strong> {{formGradeModel.IdNombres}}</li>
                        <li><strong>Apellidos:</strong> {{formGradeModel.IdApellidos}}</li>
                        <li><strong>Dirección:</strong> {{formGradeModel.IdAddress}}</li>
                        <li><strong>Ciudad:</strong> {{dataObjAllFind($store.state.CityListRes, formGradeModel.IdCityRes).value}}</li>
                        <li><strong>Departamento:</strong> {{dataObjAllFind($store.state.StateList, formGradeModel.IdStateRes).value}}</li>
                        <li><strong>Teléfono Celular:</strong> {{formGradeModel.IdPhone}}</li>
                        <li><strong>Correo Personal:</strong> {{formGradeModel.IdMail}}</li>
                        <li><strong>Correo Institucional:</strong> {{formGradeModel.IdMailStu}}</li>
                        <li><strong>Asistencia presencial:</strong> {{formGradeModel.IdAssistent}}</li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <div class="card p-3 shadow-sm h-100">
                      <h5 class="summary-title"><i class="fa fa-graduation-cap mr-2"></i>Datos Programa Grado</h5>
                      <ul class="summary-list">
                        <li><strong>Programa:</strong> {{dataObjAllFind($store.state.ProgramList2, formGradeModel.IdInteProgram).value}}</li>
                        <li><strong>Tipo de Programa:</strong> {{dataObjAllFind($store.state.ModalityList, formGradeModel.IdModalidad).value}}</li>
                        <li><strong>Operador:</strong> {{dataObjAllFind($store.state.OperatorGradeList, formGradeModel.IdOperator).value}}</li>
                        <li><strong>Grado:</strong> {{Period_Grade}}</li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-12 mb-3">
                    <div class="card p-3 shadow-sm">
                      <h5 class="summary-title"><i class="fa fa-file-text-o mr-2"></i>Documentos</h5>
                      <ul class="summary-list">
                        <li><strong>Documento de Identidad:</strong> {{formGradeFileModel.IdDocumentFile}}</li>
                        <li v-if="ModalitySelected === 'PREGRADO'"><strong>Resultados o certificado de asistencia de SABER PRO:</strong> {{formGradeFileModel.SaberProFile}}</li>
                        <li v-if="ModalitySelected === 'PREGRADO'"><strong>Acta o diploma de Bachiller:</strong> {{formGradeFileModel.DipBachFile}}</li>
                        <li v-if="ModalitySelected === 'PREGRADO'"><strong>Resultados SABER 11:</strong> {{formGradeFileModel.ResSaber11File}}</li>
                        <li v-if="ModalitySelected === 'POSGRADO' || ModalitySelected === 'MAESTRIA'"><strong>Acta o diploma de Pregrado:</strong> {{formGradeFileModel.DipPreFile}}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-content>
      </form-wizard>
    </div>
    </div>
  </div>
</template>

<script>
import FormDataGrades from '@/components/Grades/FormLayoutGrades.vue'
import FormDataFinishGrades from '@/components/Grades/FormFinishGrades.vue'
import formGrade from '@/components/Forms.vue'
import IberoHelpers from '@/store/helpers.js'

// import Formulario from '@/components/forms/Forms.vue'
// import IberoHelpers from '@/store/helpers.js'

export default {
  name: 'FormGrades',
  components: {
    FormDataGrades,
    formGrade,
    FormDataFinishGrades,
  },
  methods: {
    closeModel: function () {
      if (this.redirect === false) {
        this.modalShow = false
      } else {
        this.modalShow = false
        window.location.href = '/admin/dashboard'
      }
    },
    PeriodGrades: function () {
      console.log('here')
      var ListGrades = IberoHelpers.getGradeActive(this.$store, '', 0)
      ListGrades.then(Response => {
        this.Period_Grade = Response.data[0].Period_Grade
        this.End_Insc = Response.data[0].dat_EndInscription
        debugger
        var up_forms = document.getElementById('div_IdAssistent')
          ? document.getElementById('div_IdAssistent').getElementsByClassName('titleRef')
          : null
        if (up_forms && up_forms[0]) {
          if (Response.data[0].existCeremony === 'No') {
            up_forms[0].innerHTML = "<p style='font-weight: normal; color: #d0ab4b;'>Este proceso de grado <strong>NO CUENTA CON CONMEMORACIÓN</strong>, por lo cual es importante que respondas la siguiente pregunta. <strong>¿Desea participar en la próxima conmemoración para recibir en físico diploma y acta, por lo cual NO ENVIAREMOS tu paquete de grado (diploma y acta) a tu domicilio?</strong></p>"
          } else {
            up_forms[0].innerHTML = "Deseas participar en la ceremonia presencial?"
          }
        }
      })
    },
    validationAlfanumeric: function (data) {
      var regex = new RegExp('^[a-zA-Z0-9]+$')
      if (!regex.test(data)) {
        // alert('Estimado(a) estudiante: Es importante que la información diligenciada en el campo de Documento de Identidad no contenga puntos, comas, espacios o caracteres especiales')
        this.infoMsgModal = 'Estimado(a) estudiante: Es importante que la información diligenciada en el campo de Documento de Identidad no contenga puntos, comas, espacios o caracteres especiales.'
        this.redirect = false
        this.modalShow = true
        return false
      } else return true
    },
    ValidationTerm: function (data) {
      if (data === false || data === '' || data === 'undefined') {
        this.infoMsgModal = 'Para avanzar en necesario que acepte los terminos y condiciones.'
        this.redirect = false
        this.modalShow = true
        // alert('Estimado(a) estudiante: para avanzar en necesario que acepte los terminos y condiciones')
      } else return true
    },
    ValidationFile: function (data) {
      if (data === false) {
        alert('PRUEBA')
        return false
      } else return true
    },
    loadFindData: function (restJson) {
      document.getElementById('IdDocument').readOnly = true
      document.getElementById('IdBanner').readOnly = true
      document.getElementById('IdNombres').readOnly = true
      document.getElementById('IdApellidos').readOnly = true
      document.getElementById('IdMailStu').readOnly = true
      this.formGradeModel.IdDocType = restJson.type_Document
      this.formGradeModel.IdDocument = restJson.id_Document
      this.formGradeModel.IdBanner = restJson.id_Banner
      this.formGradeModel.IdNombres = restJson.names
      this.formGradeModel.IdApellidos = restJson.lastNames
      this.formGradeModel.IdAddress = restJson.address
      this.formGradeModel.IdPhone = restJson.cell_Phone
      this.formGradeModel.IdMailStu = restJson.email_Institutional
      this.formGradeModel.IdMail = restJson.email_Person
      this.formGradeModel.IdInteProgram = this.$store.state.ProgramList2
      this.formGradeModel.IdModalidad = this.$store.state.ModalityList
      this.formGradeModel.IdOperator = this.$store.state.OperatorGradeList
    },
    clearFields: function () {
      document.getElementById('IdDocument').readOnly = true
      document.getElementById('IdBanner').readOnly = true
      document.getElementById('IdNombres').readOnly = true
      document.getElementById('IdApellidos').readOnly = true
      document.getElementById('IdMailStu').readOnly = true
      this.formGradeModel.IdDocType = ''
      this.formGradeModel.IdDocument = ''
      this.formGradeModel.IdBanner = ''
      this.formGradeModel.IdNombres = ''
      this.formGradeModel.IdApellidos = ''
      this.formGradeModel.IdAddress = ''
      this.formGradeModel.IdPhone = ''
      this.formGradeModel.IdMailStu = ''
      this.formGradeModel.IdMail = ''
      this.formGradeModel.IdStateRes = ''
      this.formGradeModel.IdCityRes = ''
    },
    dataformat: function (InfDaT) {
      return IberoHelpers.dataObjDate(InfDaT)
    },
    dataObjFindJs: function (infoDaT, FinDaT) {
      return IberoHelpers.dataObjFind(infoDaT, FinDaT)
    },
    dataObjAllFind: function (infoDaT, FinDaT) {
      return IberoHelpers.dataObjAllFind(infoDaT, FinDaT)
    },
    executeProcess: function (event) {
      var dataFile = ''
      var fileData = ''

      switch (event.target.id) {
        case 'IdAssistent':
          this.actualizarNotaAsistencia(event.target.value)
          break
        case 'IdInteProgram':
          this.formGradeModel.IdOperator = this.formGradeModel.IdInteProgram
          this.formGradeModel.IdModalidad = this.formGradeModel.IdInteProgram

          break
        case 'IdDocumentFile':
          this.DocumentFileModel = []
          if (event.target.files.length >= 1) {
            dataFile = event.target.files[0].type
            if (dataFile.includes('pdf')) {
              fileData = event.target.files[0]
              event.target.nextElementSibling.innerText = fileData.name
              this.formGradeFileModel.IdDocumentFile = fileData.name
              this.DocumentFileModel.push({ filedata: fileData })
            } else {
              // alert('Extension no valida, solo se aceptan archivos con extension .pdf')
              this.infoMsgModal = 'Extension no valida, solo se aceptan archivos con extension .pdf'
              this.redirect = false
              this.modalShow = true
            }
          }

          break
        case 'SaberProFile':
          this.SaberProFileModel = []
          if (event.target.files.length >= 1) {
            dataFile = event.target.files[0].type
            if (dataFile.includes('pdf')) {
              fileData = event.target.files[0]
              event.target.nextElementSibling.innerText = fileData.name
              this.formGradeFileModel.SaberProFile = fileData.name
              this.SaberProFileModel.push({ filedata: fileData })
            } else {
              // alert('Extension no valida, solo se aceptan archivos con extension .pdf')
              this.infoMsgModal = 'Extension no valida, solo se aceptan archivos con extension .pdf'
              this.redirect = false
              this.modalShow = true
            }
          }
          break
        case 'DipBachFile':
          this.DipBachFileModel = []
          if (event.target.files.length >= 1) {
            dataFile = event.target.files[0].type
            if (dataFile.includes('pdf')) {
              fileData = event.target.files[0]
              event.target.nextElementSibling.innerText = fileData.name
              this.formGradeFileModel.DipBachFile = fileData.name
              this.DipBachFileModel.push({ filedata: fileData })
            } else {
              // alert('Extension no valida, solo se aceptan archivos con extension .pdf')
              this.infoMsgModal = 'Extension no valida, solo se aceptan archivos con extension .pdf'
              this.redirect = false
              this.modalShow = true
            }
          }
          break
        case 'ResSaber11File':
          this.ResSaber11FileModel = []
          if (event.target.files.length >= 1) {
            dataFile = event.target.files[0].type
            if (dataFile.includes('pdf')) {
              fileData = event.target.files[0]
              event.target.nextElementSibling.innerText = fileData.name
              this.formGradeFileModel.ResSaber11File = fileData.name
              this.ResSaber11FileModel.push({ filedata: fileData })
            } else {
              // alert('Extension no valida, solo se aceptan archivos con extension .pdf')
              this.infoMsgModal = 'Extension no valida, solo se aceptan archivos con extension .pdf'
              this.redirect = false
              this.modalShow = true
            }
          }
          break
        case 'DipPreFile':
          this.DipPreFileModel = []
          if (event.target.files.length >= 1) {
            dataFile = event.target.files[0].type
            if (dataFile.includes('pdf')) {
              fileData = event.target.files[0]
              event.target.nextElementSibling.innerText = fileData.name
              this.formGradeFileModel.DipPreFile = fileData.name
              this.DipPreFileModel.push({ filedata: fileData })
            } else {
              // alert('Extension no valida, solo se aceptan archivos con extension .pdf')
              this.infoMsgModal = 'Extension no valida, solo se aceptan archivos con extension .pdf'
              this.redirect = false
              this.modalShow = true
            }
          }
          break
        // case 'PhotoFile':
        //   this.PhotoFileModel = []
        //   if (event.target.files.length >= 1) {
        //     dataFile = event.target.files[0].type
        //     if (dataFile.includes('jpeg') || dataFile.includes('png')) {
        //       fileData = event.target.files[0]
        //       event.target.nextElementSibling.innerText = fileData.name
        //       this.formGradeFileModel.PhotoFile = fileData.name
        //       this.PhotoFileModel.push({ filedata: fileData })
        //     } else {
        //       // alert('Extension no valida, solo se aceptan archivos con extension png/jpg')
        //       this.infoMsgModal = 'Extension no valida, solo se aceptan archivos con extension png/jpg'
        //       this.redirect = false
        //       this.modalShow = true
        //     }
        //   }
        //   break

        case 'IdStateRes':
          this.formGradeModel.IdCityRes = ''
          if (event.target.value === '') {
            this.formGrade.fields1[8].values = ''
          } else {
            IberoHelpers.getCitiesListByState(this.$store.state.ApiIbero.WSParametric, this.$store.state.CityListRes, event.target.value)
            this.formGrade.fields1[8].values = this.$store.state.CityListRes
          }
          break
      }
    },
    onComplete: function () {
      let refeFileDoc = []
      // let refeFilePho = []
      let refeFileBac = []
      let refeFileSab = []
      let refeFileSabPro = []
      let refeFileDipPre = []
      var dataFile = ''
      this.alertdanger = false

      let loader = this.$loading.show({
        container: null,
        canCancel: false,
        message: 'Enviando información Registro y Control'
      })

      return new Promise((resolve, reject) => {
        var ModalitySelect = this.dataObjAllFind(this.$store.state.ModalityList, this.formGradeModel.IdModalidad).value
        var filename = this.formGradeModel.IdDocument + this.formGradeModel.IdInteProgram + this.Period_Grade + '.pdf'

        dataFile = IberoHelpers.sendUpdloadFileChangeName(this.$store, this.DocumentFileModel, 'GRADE_DOCUMENT', filename, 0)
        dataFile.then(Response => {
          if (!(Response === false)) {
            for (var i = 0; i < Response.length; i++) {
              let valueRef = Response[i].wsDocument.data.id_File
              let URIFile = Response[i].wsDocument.data.filePath
              refeFileDoc.push({ valueRef, URIFile: URIFile })
            }
            // dataFile = IberoHelpers.sendUpdloadFile(this.$store, this.PhotoFileModel, 'GRADE_PHOTO', 0)
            // dataFile.then(Response => {
            //   if (!(Response === false)) {
            //     for (var i = 0; i < Response.length; i++) {
            //       let valueRef = Response[i].wsDocument.data.id_File
            //       let URIFile = Response[i].wsDocument.data.filePath
            //       refeFilePho.push({ valueRef, URIFile: URIFile })
            //     }

            if (ModalitySelect === 'PREGRADO') {
              dataFile = IberoHelpers.sendUpdloadFileChangeName(this.$store, this.DipBachFileModel, 'GRADE_BACHILLER', filename, 0)
              dataFile.then(Response => {
                if (!(Response === false)) {
                  for (var i = 0; i < Response.length; i++) {
                    let valueRef = Response[i].wsDocument.data.id_File
                    let URIFile = Response[i].wsDocument.data.filePath
                    refeFileBac.push({ valueRef, URIFile: URIFile })
                  }
                  dataFile = IberoHelpers.sendUpdloadFileChangeName(this.$store, this.ResSaber11FileModel, 'GRADE_SABER11', filename, 0)
                  dataFile.then(Response => {
                    if (!(Response === false)) {
                      for (var i = 0; i < Response.length; i++) {
                        let valueRef = Response[i].wsDocument.data.id_File
                        let URIFile = Response[i].wsDocument.data.filePath
                        refeFileSab.push({ valueRef, URIFile: URIFile })
                      }
                      dataFile = IberoHelpers.sendUpdloadFileChangeName(this.$store, this.SaberProFileModel, 'GRADE_SABERPRO', filename, 0)
                      dataFile.then(Response => {
                        if (!(Response === false)) {
                          for (var i = 0; i < Response.length; i++) {
                            let valueRef = Response[i].wsDocument.data.id_File
                            let URIFile = Response[i].wsDocument.data.filePath
                            refeFileSabPro.push({ valueRef, URIFile: URIFile })
                          }

                          var FileGrade = {
                            idTypeDocument: this.formGradeModel.IdDocType,
                            type_Document: this.dataObjAllFind(this.$store.state.DocTypesList, this.formGradeModel.IdDocType).value,
                            Identification: this.formGradeModel.IdDocument,
                            idBanner: this.formGradeModel.IdBanner,
                            FirstPerson: this.formGradeModel.IdNombres,
                            LastName: this.formGradeModel.IdApellidos,
                            Address: this.formGradeModel.IdAddress,
                            CellPhone: this.formGradeModel.IdPhone,
                            EmailStu: this.formGradeModel.IdMailStu,
                            EmailPers: this.formGradeModel.IdMail,
                            State: this.dataObjAllFind(this.$store.state.StateList, this.formGradeModel.IdStateRes).value,
                            City: this.dataObjAllFind(this.$store.state.CityListRes, this.formGradeModel.IdCityRes).value,
                            codProgram: this.formGradeModel.IdInteProgram,
                            Program: this.dataObjAllFind(this.$store.state.ProgramList2, this.formGradeModel.IdInteProgram).value,
                            typeProgram: this.dataObjAllFind(this.$store.state.ModalityList, this.formGradeModel.IdModalidad).value,
                            Operator: this.dataObjAllFind(this.$store.state.OperatorGradeList, this.formGradeModel.IdOperator).value,
                            Grade: this.Period_Grade,
                            Assistent_Grade: this.formGradeModel.IdAssistent,
                            FileDoc: refeFileDoc,
                            // FilePho: refeFilePho,
                            FileBac: refeFileBac,
                            FileSab: refeFileSab,
                            FileSabPro: refeFileSabPro,
                          }
                          var resulEnd = IberoHelpers.sendFormInscriptionGrades(this.$store, FileGrade)
                          resulEnd.then(Response => {
                            loader.hide()
                            if (!(Response === false)) {
                              if ((Response.data.status === '200') && (Response.data.message === 'Insertado')) {
                                IberoHelpers.scrollToTop(0, 500)
                                // alert("Archivos Almacenados")
                                this.infoMsgModal = 'Has efectuado tu inscripción al proceso de grados de manera satisfactoria, por favor estar pendiente de la información publicada en la página web de la IBERO y correo electronico. Recuerda que si no te llega un correo con la confirmacion de esta inscripción, posiblemente fallo el registro'
                                this.redirect = true
                                this.modalShow = true
                                resolve(true)
                              } else {
                                IberoHelpers.scrollToTop(0, 500)
                                this.infoMsgModal = Response.data.message
                                this.redirect = true
                                this.modalShow = true
                                resolve(false)
                              }
                            } else {
                              IberoHelpers.scrollToTop(0, 500)
                              this.infoMsgModal = 'Ha fallado el proceso de inscripción, consulta con el administrador'
                              this.redirect = true
                              this.modalShow = true
                              resolve(false)
                            }
                          }).catch(() => {
                            loader.hide()
                            IberoHelpers.scrollToTop(0, 500)
                            this.infoMsgModal = 'Ha fallado el proceso de inscripción, consulta con el administrador'
                            this.redirect = true
                            this.modalShow = true
                            resolve(false)
                          })
                        } else {
                          loader.hide()
                          IberoHelpers.scrollToTop(0, 300)
                          resolve(false)
                        }
                      }).catch(() => {
                        loader.hide()
                        resolve(false)
                      })
                    } else {
                      loader.hide()
                      IberoHelpers.scrollToTop(0, 300)
                      resolve(false)
                    }
                  }).catch(() => {
                    loader.hide()
                    resolve(false)
                  })
                } else {
                  loader.hide()
                  IberoHelpers.scrollToTop(0, 300)
                  resolve(false)
                }
              }).catch(() => {
                loader.hide()
                resolve(false)
              })
            }

            if ((this.ModalitySelected === 'POSGRADO') || (this.ModalitySelected === 'MAESTRIA')) {
              dataFile = IberoHelpers.sendUpdloadFileChangeName(this.$store, this.DipPreFileModel, 'GRADE_DIPPRE', filename, 0)
              dataFile.then(Response => {
                if (!(Response === false)) {
                  for (var i = 0; i < Response.length; i++) {
                    let valueRef = Response[i].wsDocument.data.id_File
                    let URIFile = Response[i].wsDocument.data.filePath
                    refeFileDipPre.push({ valueRef, URIFile: URIFile })
                  }

                  var FileGrade = {
                    idTypeDocument: this.formGradeModel.IdDocType,
                    type_Document: this.dataObjAllFind(this.$store.state.DocTypesList, this.formGradeModel.IdDocType).value,
                    Identification: this.formGradeModel.IdDocument,
                    idBanner: this.formGradeModel.IdBanner,
                    FirstPerson: this.formGradeModel.IdNombres,
                    LastName: this.formGradeModel.IdApellidos,
                    Address: this.formGradeModel.IdAddress,
                    CellPhone: this.formGradeModel.IdPhone,
                    EmailStu: this.formGradeModel.IdMailStu,
                    EmailPers: this.formGradeModel.IdMail,
                    State: this.dataObjAllFind(this.$store.state.StateList, this.formGradeModel.IdStateRes).value,
                    City: this.dataObjAllFind(this.$store.state.CityListRes, this.formGradeModel.IdCityRes).value,
                    codProgram: this.formGradeModel.IdInteProgram,
                    Program: this.dataObjAllFind(this.$store.state.ProgramList2, this.formGradeModel.IdInteProgram).value,
                    typeProgram: this.dataObjAllFind(this.$store.state.ModalityList, this.formGradeModel.IdModalidad).value,
                    Operator: this.dataObjAllFind(this.$store.state.OperatorGradeList, this.formGradeModel.IdOperator).value,
                    Grade: this.Period_Grade,
                    Assistent_Grade: this.formGradeModel.IdAssistent,
                    FileDoc: refeFileDoc,
                    // FilePho: refeFilePho,
                    FileDipPre: refeFileDipPre,
                  }

                  var resulEnd = IberoHelpers.sendFormInscriptionGrades(this.$store, FileGrade)
                  resulEnd.then(Response => {
                    loader.hide()
                    if (!(Response === false)) {
                      console.log()
                      if ((Response.data.status === '200') && (Response.data.message === 'Insertado')) {
                        IberoHelpers.scrollToTop(0, 500)
                        // alert("Archivos Almacenados")
                        this.infoMsgModal = 'Has efectuado tu inscripción al proceso de grados de manera satisfactoria, por favor estar pendiente de la información publicada en la página web de la IBERO y correo electronico. Recuerda que si no te llega un correo con la confirmacion de esta inscripción, posiblemente fallo el registro'
                        this.redirect = true
                        this.modalShow = true
                        resolve(true)
                      } else {
                        IberoHelpers.scrollToTop(0, 500)
                        this.infoMsgModal = Response.data.message
                        this.redirect = true
                        this.modalShow = true
                        resolve(false)
                      }
                    } else {
                      IberoHelpers.scrollToTop(0, 500)
                      this.infoMsgModal = 'Ha fallado el proceso de inscripción, consulta con el administrador'
                      this.redirect = true
                      this.modalShow = true
                      resolve(false)
                    }
                  }).catch(() => {
                    loader.hide()
                    IberoHelpers.scrollToTop(0, 500)
                    this.infoMsgModal = 'Ha fallado el proceso de inscripción, consulta con el administrador'
                    this.redirect = true
                    this.modalShow = true
                    resolve(false)
                  })
                } else {
                  loader.hide()
                  IberoHelpers.scrollToTop(0, 300)
                  resolve(false)
                }
              }).catch(() => {
                loader.hide()
                resolve(false)
              })
            }
            //   }
            // })
          } else {
            loader.hide()
            IberoHelpers.scrollToTop(0, 300)
            resolve(false)
          }
        }).catch(() => {
          loader.hide()
          resolve(false)
        })
      })
    },
    beforeTabSwitch0: function () {
      let loader = this.$loading.show()
      if (this.ValidationTerm(this.formGradeModel.IdTermiCondiGene) === true) {
        return new Promise((resolve, reject) => {
          this.$refs.obsFields0.validate().then(results => {
            if (!results) {
              IberoHelpers.scrollToTop(0, 500)
              resolve(false)
            } else {
              this.clearFields()
              var exPerson = IberoHelpers.getDataPersonGrade(this.$store, this.$session.get('IberoJWTAdminLogin').idPerson)
              exPerson.then(Response => {
                if (!(Response === false)) {
                  if (Response.status === 200) {
                    this.loadFindData(Response.data.persondata)
                    this.PeriodGrades()
                    loader.hide()
                    resolve(true)
                  } else {
                    loader.hide()
                    this.infoMsgModal = 'Se ha generado un error con el servicio, consulte con el administrador'
                    this.redirect = false
                    this.modalShow = true
                    resolve(false)
                  }
                } else {
                  loader.hide()
                  this.infoMsgModal = 'Se ha generado un error con el servicio, consulte con el administrador'
                  this.redirect = false
                  this.modalShow = true
                  resolve(false)
                }
              })
            }
          })
        })
      } else {
        loader.hide()
        return ''
      }
    },
    beforeTabSwitch1: function () {
      var ModalitySelect = this.dataObjAllFind(this.$store.state.ModalityList, this.formGradeModel.IdModalidad)
      this.ModalitySelected = ModalitySelect.value
      return new Promise((resolve, reject) => {
        this.$refs.obsFields1.validate().then(results => {
          if (!results) {
            IberoHelpers.scrollToTop(0, 500)
            resolve(false)
          } else {
            let loader = this.$loading.show()
            var ListGrades = IberoHelpers.ValidationsGrade(this.$store, this.formGradeModel, this.Period_Grade)
            ListGrades.then(Response => {
              if ((Response.data.status === '400') || (Response.data.title === 'Failed')) {
                // alert("Se ha generado un error con el servicio, consulte con el administrador")
                loader.hide()
                this.infoMsgModal = Response.data.message
                this.redirect = false
                this.modalShow = true
                resolve(false)
              } else {
                if (Response.data.message.includes('No Aprobado')) {
                  // alert(Response.data.title)
                  var msj = Response.data.message
                  this.infoMsgModal = msj.replace('No Aprobado, ', '')
                  loader.hide()
                  this.redirect = false
                  this.modalShow = true
                  resolve(false)
                } else {
                  if (this.ModalitySelected === 'PREGRADO') {
                    document.getElementById('div_SaberProFile').classList.remove('noShow')
                    this.formGrade.fields2[1].validate.required = false
                    document.getElementById('div_DipBachFile').classList.remove('noShow')
                    this.formGrade.fields2[2].validate.required = false
                    document.getElementById('div_ResSaber11File').classList.remove('noShow')
                    this.formGrade.fields2[3].validate.required = false
                    document.getElementById('div_DipPreFile').classList.add('noShow')
                    this.formGrade.fields2[4].validate.required = false
                    loader.hide()
                    resolve(true)
                  }

                  if ((this.ModalitySelected === 'POSGRADO') || (this.ModalitySelected === 'MAESTRIA')) {
                    document.getElementById('div_SaberProFile').classList.add('noShow')
                    this.formGrade.fields2[1].validate.required = false
                    document.getElementById('div_DipBachFile').classList.add('noShow')
                    this.formGrade.fields2[2].validate.required = false
                    document.getElementById('div_ResSaber11File').classList.add('noShow')
                    this.formGrade.fields2[3].validate.required = false

                    document.getElementById('div_DipPreFile').classList.remove('noShow')
                    this.formGrade.fields2[4].validate.required = false
                    loader.hide()
                    resolve(true)
                  }
                }
              }
            })
          }
        })
      })
    },
    ValidateFile: function () {
      if ((this.ModalitySelected === 'POSGRADO') || (this.ModalitySelected === 'MAESTRIA')) {
        // if ((this.DocumentFileModel.length > 0) && (this.DipPreFileModel.length > 0) && (this.PhotoFileModel.length > 0)) {
        if ((this.DocumentFileModel.length > 0) && (this.DipPreFileModel.length > 0)) {
          return true
        }
      }

      if (this.ModalitySelected === 'PREGRADO') {
        // if ((this.DocumentFileModel.length > 0) && (this.SaberProFileModel.length > 0) && (this.DipBachFileModel.length > 0) && (this.ResSaber11FileModel.length > 0) && (this.PhotoFileModel.length > 0)) {
        if ((this.DocumentFileModel.length > 0) && (this.SaberProFileModel.length > 0) && (this.DipBachFileModel.length > 0) && (this.ResSaber11FileModel.length > 0)) {
          return true
        }
      }
    },
    beforeTabSwitch2: function () {
      return new Promise((resolve, reject) => {
        if (this.ValidateFile()) {
          this.$refs.obsFields2.validate().then(results => {
            if (!results) {
              IberoHelpers.scrollToTop(0, 500)
              resolve(false)
            } else {
              this.alertdanger = false
              resolve(true)
            }
          })
        } else {
          this.alertdanger = true
          resolve(false)
        }
      })
    },
    actualizarNotaAsistencia: function (valor) {
      var campo = this.formGrade.fields1.find(f => f.id === 'IdAssistent')
      if (campo) {
        if (valor === 'Si') {
          campo.note = '<i class="fa fa-info-circle"></i> <strong>Nota:</strong> Por favor tener presente que la disponibilidad está sujeta a cupo.'
        } else {
          campo.note = ''
        }
      }
    },
  },
  watch: {
    'formGradeModel.IdAssistent': function (newVal) {
      this.actualizarNotaAsistencia(newVal)
    },
  },
  created () {
  },
  data () {
    return {
      modalShow: false,
      FormGrades: true,
      infoValidacion: true,
      alertdanger: false,
      NoDataFound: false,
      alertdangerOrden: false,
      redirect: false,
      infoMsgModal: '',
      sumaryData: [],
      infoPerson: null,
      ProgramPerson: [],
      OperatorPerson: [],
      ModalitySelected: '',
      SaberProFileModel: [],
      DocumentFileModel: [],
      DipBachFileModel: [],
      ResSaber11FileModel: [],
      DipPreFileModel: [],
      // PhotoFileModel: [],
      Period_Grade: '',
      End_Insc: '',
      newState: {},
      TitleInscrip: 'Formulario de Inscripción de Grados',
      labelFields: {
        fields0: 'Informacion General',
        fields1: 'Datos Inscripción',
        fields2: 'Documentación',
        fields3: 'Finalización',
      },
      formGradeModel: {
        IdTermiCondiGene: '',
        IdDocType: '',
        IdDocument: '',
        IdBanner: '',
        IdNombres: '',
        IdApellidos: '',
        IdInteProgram: [],
        IdModalidad: [],
        IdAddress: '',
        IdPhone: '',
        IdMailStu: '',
        IdMail: '',
        IdOperator: 1,
        IdStateRes: '',
        IdCityRes: '',
        IdAssistent: '',
      },
      formGradeFileModel: {
        IdDocumentFile: '',
        SaberProFile: '',
        DipBachFile: '',
        ResSaber11File: '',
        DipPreFile: '',
        // PhotoFile: '',
      },

      formGrade: {
        fields0: [
          {
            id: 'IdTermiCondiGene',
            name: 'Términos y Condiciones',
            model: 'IdTermiCondiGene',
            type: 'accepted',
            disabled: false,
            placeholder: 'Acepto los <a class="linkTerm" href="' + this.$store.state.linkTermiCondi + '" target="_blank">Términos y Condiciones</a> de uso.',
            values: '',
            validate: {
              required: true,
            },
            class: 'col-md-12 linkref',
          },
        ],
        fields1: [
          {
            id: 'IdDocType',
            model: 'IdDocType',
            name: 'Tipo de Documento',
            type: 'Select',
            disabled: true,
            placeholder: 'Tipo de Documento',
            values: this.$store.state.DocTypesList,
            validate: {
              required: true,
            },
            class: 'col-md-12',
          },
          {
            id: 'IdDocument',
            model: 'IdDocument',
            name: 'Documento de Identidad',
            type: 'input',
            placeholder: 'Documento de Identidad',
            readonly: 'isReadOnly',
            values: '',
            validate: {
              required: true,
              min: 6,
              max: 15,
            },
            class: 'col-md-6',
          },
          {
            id: 'IdBanner',
            model: 'IdBanner',
            name: 'Codigo del Estudiante',
            type: 'input',
            placeholder: 'Codigo del Estudiante',
            readonly: 'isReadOnly',
            values: '',
            validate: {
              required: true,
              min: 9,
              max: 12,
            },
            class: 'col-md-6',
          },
          {
            id: 'IdNombres',
            model: 'IdNombres',
            name: 'Nombres',
            type: 'input',
            placeholder: 'Nombres',
            readonly: 'isReadOnly',
            values: '',
            validate: {
              required: true,
            },
            class: 'col-md-6',
          },
          {
            id: 'IdApellidos',
            model: 'IdApellidos',
            name: 'Apellidos',
            type: 'input',
            placeholder: 'Apellidos',
            readonly: 'isReadOnly',
            values: '',
            validate: {
              required: true,
            },
            class: 'col-md-6',
          },
          {
            id: 'IdAddress',
            model: 'IdAddress',
            name: 'Dirección de Residencia',
            type: 'inputkey',
            placeholder: 'Dirección de Residencia',
            values: '',
            validate: {
              required: true,
            },
            class: 'col-md-12',
          },
          {
            id: 'IdPhone',
            model: 'IdPhone',
            name: 'Teléfono Celular',
            type: 'input',
            placeholder: 'Teléfono Celular',
            values: '',
            validate: {
              required: false,
              numeric: true,
              max: 10,
              min: 10,
            },
            class: 'col-md-12',
          },
          {
            id: 'IdStateRes',
            model: 'IdStateRes',
            name: 'Departamento de Residencia',
            type: 'Select',
            placeholder: 'Departamento de Residencia',
            class: 'col-md-6',
            values: this.$store.state.StateList,
            validate: {
              required: true,
            },
          },
          {
            id: 'IdCityRes',
            model: 'IdCityRes',
            name: 'Ciudad de Residencia',
            type: 'Select',
            placeholder: 'Ciudad de Residencia',
            validate: {
              required: true,
            },
            class: 'col-md-6',
            values: '',
          },
          {
            id: 'IdMailStu',
            model: 'IdMailStu',
            name: 'Correo Electrónico Institucional',
            type: 'input',
            placeholder: 'Correo Electrónico Institucional',
            readonly: 'isReadOnly',
            values: '',
            validate: {
              required: true,
              email: true,
            },
            class: 'col-md-6',
          },
          {
            id: 'IdMail',
            model: 'IdMail',
            name: 'Correo Electrónico Personal',
            type: 'input',
            placeholder: 'Correo Electrónico Personal',
            values: '',
            validate: {
              required: true,
              email: true,
            },
            class: 'col-md-6',
          },
          {
            id: 'IdInteProgram',
            model: 'IdInteProgram',
            name: 'Programa de Interés',
            type: 'Select',
            placeholder: 'Programa de Interés',
            class: 'col-md-12',
            validate: {
              required: true,
            },
            values: this.$store.state.ProgramList2,
          },
          {
            id: 'IdModalidad',
            model: 'IdModalidad',
            name: 'Modalidad',
            type: 'Select',
            disabled: true,
            placeholder: 'Modalidad',
            class: 'col-md-12',
            values: this.$store.state.ModalityList,
            validate: {
              required: true,
            },
          },
          {
            id: 'IdOperator',
            model: 'IdOperator',
            name: 'Operador',
            type: 'Select',
            disabled: true,
            placeholder: 'Operador',
            values: this.$store.state.OperatorGradeList,
            validate: {
              required: true,
            },
            class: 'col-md-12 noShow',
            hidden: true,
          },
          {
            id: 'IdAssistent',
            model: 'IdAssistent',
            name: 'Deseas participar en la ceremonia presencial?',
            placeholder: 'Seleccione opción',
            type: 'Select',
            values: [
              { id: 'Si', value: 'Si deseo participar de la Ceremonia' },
              { id: 'No', value: 'No deseo participar de la Ceremonia' },
            ],
            validate: {
              required: true,
            },
            class: 'col-md-12',
            note: '',
          },
        ],
        fields2: [
          {
            id: 'IdDocumentFile',
            placeholder: 'Examinar',
            name: 'Documento de Identidad (PDF)',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            ref: 'IdDocumentFile',
          },
          {
            id: 'SaberProFile',
            placeholder: 'Examinar',
            name: 'Resultados o certificado de asistencia de SABER PRO (PDF)',
            type: 'file',
            values: '',
            class: 'col-md-12',
            ref: 'SaberProFile',
            validate: {
              required: false,
            },
          },
          {
            id: 'DipBachFile',
            placeholder: 'Examinar',
            name: 'Acta o diploma de Bachiller (PDF)',
            type: 'file',
            values: '',
            class: 'col-md-12',
            ref: 'DipBachFile',
            validate: {
              required: false,
            },
          },
          {
            id: 'ResSaber11File',
            placeholder: 'Examinar',
            name: 'Resultados SABER 11 (PDF)',
            type: 'file',
            values: '',
            class: 'col-md-12',
            ref: 'ResSaber11File',
            validate: {
              required: false,
            },
          },
          {
            id: 'DipPreFile',
            placeholder: 'Examinar',
            name: 'Acta o diploma de Pregrado (PDF)',
            type: 'file',
            values: '',
            class: 'col-md-12',
            validate: {
              required: false,
            },
            ref: 'DipPreFile',
          },
          // {
          //   id: 'PhotoFile',
          //   placeholder: 'Examinar',
          //   name: 'Foto (JPG)',
          //   type: 'file',
          //   values: '',
          //   validate: {
          //     required: false,
          //   },
          //   class: 'col-md-12',
          //   ref: 'PhotoFile',
          // },
        ],
      },
    }
  },
}
</script>

<style scoped>
.FormGrades {
  background: #fff;
  border-radius: 10px;
  padding: 30px 35px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, .08);
}

.FormGrades2 {
  background: #fff;
}

.noShow {
  display: none !important;
}

.totalform {
  padding: 30px 20px;
  background: #fff;
}

.intro {
  color: #a2273c;
  font-size: 30px;
  font-weight: 500;
  margin-bottom: 30px;
  text-align: center;
}

.alert {
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 20px;
}

.refNoData {
  font-weight: 600;
  padding: 12px 16px;
  margin-top: 20px;
  border-radius: 8px;
}

.d-block h3 {
  font-size: 17px;
  line-height: 1.5;
}

.modal-close-btn {
  background: white !important;
  color: #222 !important;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-weight: 600;
}

.modal-close-btn:hover {
  background: #222 !important;
  color: white !important;
}

/* Resumen final */
.summary-title {
  color: #a2273c;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 12px;
  padding-bottom: 6px;
  border-bottom: 2px solid #f1f5f9;
}

.summary-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
}

.summary-list li {
  padding: 6px 0;
  font-size: 14px;
  color: #334155;
  border-bottom: 1px solid #f8fafc;
}

.summary-list li strong {
  color: #0f172a;
}

/* Reglas profundas para componentes hijos (vue-form-wizard, Forms) */
::v-deep .wizard-nav-pills {
  margin-bottom: 30px !important;
}

::v-deep .wizard-card-footer {
  margin-top: 20px !important;
}

::v-deep .wizard-btn {
  background: white !important;
  color: #222 !important;
  border: 2px solid #222 !important;
  border-radius: 6px;
  font-weight: 600;
  padding: 8px 18px;
  transition: .2s ease;
}

::v-deep .wizard-btn:hover {
  background: #222 !important;
  color: white !important;
}

::v-deep .wizard-icon-circle {
  background: #d0ab4b !important;
  border-color: #d0ab4b !important;
  color: #fff !important;
}

::v-deep .wizard-icon-container {
  background: transparent !important;
  border-radius: 50%;
}

::v-deep .vue-form-wizard .active .wizard-icon-circle {
  background: #a2273c !important;
  border-color: #a2273c !important;
  color: white !important;
}

::v-deep .vue-form-wizard .checked .wizard-icon-circle {
  background: #16a34a !important;
  border-color: #16a34a !important;
  color: white !important;
}

::v-deep .vue-form-wizard .wizard-progress-bar {
  background: #a2273c !important;
}

::v-deep .linkref {
  font-weight: 600;
  margin-bottom: 15px;
}

::v-deep .linkref a {
  color: #f2a900 !important;
  font-weight: 600;
}

/* Títulos y contenido de asistencia en amarillo dorado */
::v-deep .titleRef {
  color: #d0ab4b;
}

::v-deep #div_IdAssistent .titleRef,
::v-deep #div_IdAssistent .titleRef p,
::v-deep #div_IdAssistent .titleRef strong {
  color: #d0ab4b !important;
}

::v-deep #div_IdAssistent .titleRef p {
  line-height: 1.6;
  margin-bottom: 8px;
}

/* Checkbox alignment */
::v-deep input[type="checkbox"] {
  width: auto !important;
  display: inline-block !important;
  margin-right: 8px !important;
  cursor: pointer;
}

/* Custom file styling */
::v-deep .custom-file {
  position: relative;
  display: block;
  width: 100%;
}

::v-deep .custom-file-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0 !important;
  z-index: 2;
  cursor: pointer;
}

::v-deep .custom-file-label {
  display: block;
  width: 100%;
  padding: 10px 14px;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  color: #6b7280;
  cursor: pointer;
}

::v-deep .custom-file-label::after {
  content: "Examinar";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  padding: 0 16px;
  background: #f3f4f6;
  border-left: 1px solid #d1d5db;
  border-radius: 0 8px 8px 0;
  color: #374151;
  font-weight: 500;
}
</style>
